import { moneyFormat } from 'design-system';

import { deductibleCoverages } from 'data-layer-cr/dist/functions/coverages';
import { getDeductibleCoverages } from 'data-layer-cr/dist/functions/quotations';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
  QuotationCoverage,
} from 'data-layer-cr/dist/models';

import CatalogItem from '../../../../../models/helperTypes/CatalogItem';

// Components
import { CardQuotation } from '../../components';

const { formatMoney } = moneyFormat;

type Props = {
  quotation: Quotation;
  coverages: CoverageCatalog[];
  coverageResumes: CoverageCatalogResume[];
};

function quotationDeductibleValueForCode(
  quotationCoverages: QuotationCoverage[],
  code: string,
): number {
  const foundSimplifiedCoverage = quotationCoverages.filter(
    (curSimplifiedCoverage): boolean => {
      return curSimplifiedCoverage.coverageId === code;
    },
  )[0];
  if (foundSimplifiedCoverage) {
    return foundSimplifiedCoverage.deductible;
  }
  return 0;
}

const DeductibleDetailsCard = ({
  quotation,
  coverages,
  coverageResumes,
}: Props): JSX.Element => {
  const simplifiedCoverageList = getDeductibleCoverages(
    quotation,
    coverageResumes,
  );
  const displayItems: CatalogItem[] = [];

  deductibleCoverages(coverages).forEach(
    (currentCoverage: CoverageCatalog): void => {
      const usedValue = quotationDeductibleValueForCode(
        simplifiedCoverageList,
        currentCoverage.code,
      );
      displayItems.push({
        Value: currentCoverage.name,
        Text: formatMoney(usedValue),
      });
    },
  );

  return <CardQuotation title="Deducibles" boldDataList={displayItems} />;
};

export default DeductibleDetailsCard;
